import React, { useState } from 'react';
import { Alert, Button, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSubscription } from '../context/SubscriptionContext';
import SubscriptionDialog from './SubscriptionDialog';
import { FACEBOOK_MESSENGER_URL } from '../constants/commonConstants';
import { useNavigate } from 'react-router-dom';
import { LoadingSpinner } from './LoadingSpinner';

export default function SubscriptionGate({ game = 'poker', feature, children }) {
    const { t } = useTranslation();
    const { feature: access, data, ready, unavailable, refresh } = useSubscription();
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const value = access(game, feature);
    if (ready === false) return <LoadingSpinner show />;
    if (unavailable) return <Box className={`subscription-gate subscription-gate-${feature}`}>
        <Alert severity="warning">{t('subscription.settingsUnavailable')}</Alert>
        <Button type="button" variant="contained" onClick={refresh}>{t('gameRoom.connectionLost.retry')}</Button>
    </Box>;
    if (!value.show) return null;
    if (value.allowed) return children;
    return <Box className={`subscription-gate subscription-gate-${feature}`}>
        <Typography>{t(feature === 'game' ? `subscription.${game}` : `subscription.features.${feature}`)}</Typography>
        <Alert severity="info">{t(value.loginLocked ? 'subscription.loginRequired' : value.locked ? 'subscription.required' : 'subscription.disabled')}</Alert>
        {value.loginLocked && <Button onClick={() => navigate('/login')}>{t('auth.login')}</Button>}
        {value.locked && !value.loginLocked && <Button {...(data?.showSubscribe && data?.doExternalSubscribe
            ? { component: 'a', href: FACEBOOK_MESSENGER_URL, target: '_blank', rel: 'noopener noreferrer' }
            : { onClick: () => setOpen(true) })}>{t('subscription.title')}</Button>}
        <SubscriptionDialog open={open} onClose={() => setOpen(false)} />
    </Box>;
}
